import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const rows = [{
  icon: '⏰',
  without: '3-5 hs/semana programando desde cero',
  with: '10 min/semana. El resto es entrenar.'
}, {
  icon: '😓',
  without: 'Siempre los mismos WODs de siempre',
  with: '100+ WODs distintos listos para programar'
}, {
  icon: '💸',
  without: 'Alumnos que abandonan sin saber por qué',
  with: 'Progresión → retención visible mes a mes'
}, {
  icon: '📋',
  without: 'Sin escalado claro de nivel a nivel',
  with: '3 versiones de cada WOD para cada nivel'
}, {
  icon: '😨',
  without: 'Alumno con lesión o patología = pánico',
  with: 'Crossfit Pro™ → adaptación segura y profesional'
}, {
  icon: '👥',
  without: 'Niveles mezclados = caos en clase',
  with: 'Sistema de escalado para grupos heterogéneos'
}, {
  icon: '🏋️',
  without: 'Sin ciclo de fuerza estructurado',
  with: '12 semanas de fuerza con porcentajes calculados'
}, {
  icon: '📱',
  without: 'Sin identidad profesional visible',
  with: 'Sistema que justifica cobrar más y retener más'
}, {
  icon: '🧠',
  without: 'Sin sistema de evaluación de alumnos',
  with: 'Fichas, métricas y reunión de progreso mensual'
}, {
  icon: '💼',
  without: 'Sin estructura de negocio en el box',
  with: 'Gestión, precios, referidos y crecimiento resuelto'
}];
export function CostTable() {
  return <section className="py-12 md:py-24 px-4 bg-cf-darker border-t border-white/5" data-id="element-108">
      <div className="max-w-5xl mx-auto" data-id="element-109">
        <div className="text-center mb-8 md:mb-16" data-id="element-110">
          <h2 className="font-bebas text-3xl md:text-6xl text-white tracking-tight mb-4 leading-tight" data-id="element-111">
            EL COSTO DE NO TENER UN SISTEMA
          </h2>
        </div>

        {/* Mobile: stacked cards */}
        <div className="md:hidden space-y-3 mb-10" data-id="element-112">
          <div className="grid grid-cols-2 gap-2 text-[10px] font-bold uppercase tracking-wider px-1" data-id="element-113">
            <div className="flex items-center gap-1 text-cf-red" data-id="element-114">
              <X className="w-3 h-3" data-id="element-115" /> Sin sistema
            </div>
            <div className="flex items-center gap-1 text-cf-gold" data-id="element-116">
              <Check className="w-3 h-3" data-id="element-117" /> Con Crossfit Resuelto
            </div>
          </div>
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.04
        }} className="rounded-lg border border-white/10 bg-cf-card overflow-hidden relative" data-id="element-118">
              <div className="absolute top-2 left-1/2 -translate-x-1/2 z-10 w-7 h-7 rounded-full bg-cf-card border border-white/20 flex items-center justify-center text-base shadow-lg" data-id="element-119">
                {row.icon}
              </div>
              <div className="grid grid-cols-2 divide-x divide-white/10" data-id="element-120">
                <div className="p-3 pt-5 bg-cf-red/5" data-id="element-121">
                  <p className="text-gray-400 text-xs leading-snug" data-id="element-122">
                    {row.without}
                  </p>
                </div>
                <div className="p-3 pt-5 bg-cf-gold/5" data-id="element-123">
                  <p className="text-white text-xs font-semibold leading-snug" data-id="element-124">
                    {row.with}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Desktop: table */}
        <div className="hidden md:block overflow-x-auto pb-4 mb-10 md:mb-16" data-id="element-125">
          <table className="w-full min-w-[800px] border-collapse" data-id="element-126">
            <thead data-id="element-127">
              <tr data-id="element-128">
                <th className="p-4 text-left border-b-2 border-white/10 w-16" data-id="element-129"></th>
                <th className="p-4 text-left border-b-2 border-cf-red/50 bg-cf-red/5 text-cf-red font-bold w-1/2 text-xl" data-id="element-130">
                  <div className="flex items-center gap-2" data-id="element-131">
                    <X className="w-6 h-6" data-id="element-132" /> SIN CROSSFIT RESUELTO
                  </div>
                </th>
                <th className="p-4 text-left border-b-2 border-cf-gold bg-cf-gold/5 text-cf-gold font-bold w-1/2 text-xl" data-id="element-133">
                  <div className="flex items-center gap-2" data-id="element-134">
                    <Check className="w-6 h-6" data-id="element-135" /> CON CROSSFIT RESUELTO
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-136">
              {rows.map((row, i) => <tr key={i} className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-137">
                  <td className="p-4 text-2xl text-center" data-id="element-138">{row.icon}</td>
                  <td className="p-4 text-gray-400 bg-cf-red/5 text-lg" data-id="element-139">
                    {row.without}
                  </td>
                  <td className="p-4 text-white bg-cf-gold/5 font-bold text-lg" data-id="element-140">
                    {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-3xl mx-auto" data-id="element-141">
          <p className="text-base md:text-3xl text-gray-300 font-medium mb-3 md:mb-4" data-id="element-142">
            El próximo lunes podés volver a improvisar el WOD.
          </p>
          <p className="text-base md:text-3xl text-white font-bold mb-6 md:mb-8" data-id="element-143">
            O podés entrar al box con todo resuelto desde hoy.
          </p>
          <p className="font-bebas text-3xl md:text-5xl text-cf-red leading-tight" data-id="element-144">
            ¿Cuánto cuesta NO tenerlo?
          </p>
        </div>
      </div>
    </section>;
}